import { render, staticRenderFns } from "./speakingselection.vue?vue&type=template&id=34781e02&scoped=true&"
import script from "./speakingselection.vue?vue&type=script&lang=js&"
export * from "./speakingselection.vue?vue&type=script&lang=js&"
import style0 from "./speakingselection.vue?vue&type=style&index=0&id=34781e02&scoped=true&lang=css&"
import style1 from "./speakingselection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34781e02",
  null
  
)

export default component.exports